import { Button, Image, PasswordInput, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../utils/api";
import useStore from "../utils/store";

const Login = () => {
  const [loading, setLoading] = React.useState(false);
  const login = useStore((state) => state.login);
  const navigate = useNavigate();

  const form = useForm({
    initialValues: { email: "", password: "" },
    validate: {
      email: (v) => (v ? null : "Please input your email!"),
      password: (v) => (v ? null : "Please input your password!"),
    },
  });

  const loginUser = async (values) => {
    setLoading(true);
    try {
      const [success, data] = await loginAdmin(values);

      if (success) {
        if (data.token) {
          localStorage.setItem("tburudani_token", data.token);
          const token = localStorage.getItem("tburudani_token");
          if (token) {
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          }
        }
        login({
          ...data?.admin,
          token: data.token,
        });
        notifications.show({ title: "Success", message: "Login Successful", color: "green" });
        navigate("/");
      } else {
        notifications.show({ title: "Error", message: data.message || "Login failed", color: "red" });
      }
    } catch (error) {
      notifications.show({ title: "Error", message: "An error occurred during login", color: "red" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg-pattern" aria-hidden />
      <div className="login-glow login-glow-1" aria-hidden />
      <div className="login-glow login-glow-2" aria-hidden />
      <form className="login-card" onSubmit={form.onSubmit(loginUser)}>
        <div className="login-card-brand">
          <Image src="/logo.svg" w={56} h={56} fit="contain" alt="T-Burudani Plus" />
          <div className="login-brand-text">
            <h1>T-Burudani Plus</h1>
            <p>Admin Portal</p>
          </div>
        </div>
        <div className="login-card-body">
          <TextInput
            placeholder="Email"
            size="md"
            mb="md"
            variant="filled"
            styles={{
              input: { backgroundColor: "var(--mantine-color-dark-7)", borderColor: "var(--mantine-color-dark-5)" },
            }}
            {...form.getInputProps("email")}
          />
          <PasswordInput
            placeholder="Password"
            size="md"
            mb="xl"
            variant="filled"
            styles={{
              input: { backgroundColor: "var(--mantine-color-dark-7)", borderColor: "var(--mantine-color-dark-5)" },
            }}
            {...form.getInputProps("password")}
          />
          <Button type="submit" fullWidth size="md" loading={loading} className="login-submit-btn">
            Sign in
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Login;
